import React, { Component } from "react";
import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";

import SearchInput from "../search-input/search-input";

const noOptionDefaultValues = {
  text: "No Result",
  classes: "text-danger no-result-li",
  optionValue: "",
};

const SelectOption = ({ id, text, optionValue, selectedValue, classes = "", ...restProps }) => (
  <MenuItem
    className={`dropdown-item text-decoration-none font-weight-bold fs-10 ${classes}`}
    eventKey={optionValue}
    active={!!selectedValue && selectedValue === optionValue}
    id={`${id}-${optionValue}`}
    {...restProps}
  >
    {text}
  </MenuItem>
);

class SelectDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOptions: props.options,
      isVisible: false,
    };

    this.renderSearchFilter = this.renderSearchFilter.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }

  componentDidUpdate({ options: prevOptions }) {
    const { options } = this.props;
    if (options.length != prevOptions.length) {
      this.setState({ dropdownOptions: options });
    }
  }

  onFilter(filteredOptions) {
    this.setState({ dropdownOptions: filteredOptions });
  }

  renderSearchFilter() {
    const { options, showSearchFilter, id, searchfilterOptions = {}, name } = this.props;
    const { isVisible } = this.state;

    if (showSearchFilter) {
      return (
        <MenuItem id={`${id}-search-filter`} className="search-filter-input " header>
          <i className="icon-search" />
          <SearchInput
            id={`${id}SearchFilter`}
            name={`${name}SearchFilter`}
            {...searchfilterOptions}
            data={options}
            onFilter={this.onFilter}
            reset={!isVisible}
            focus={isVisible}
          />
        </MenuItem>
      );
    }
  }

  renderOptions() {
    const { id, value: selectedValue, noOption = noOptionDefaultValues } = this.props;
    const { dropdownOptions } = this.state;

    if (dropdownOptions.length) {
      return dropdownOptions.map(({ text, value: optionValue }) => (
        <SelectOption
          key={`${id}-${optionValue}`}
          id={id}
          text={text}
          optionValue={optionValue}
          selectedValue={selectedValue}
        />
      ));
    }
    return <SelectOption {...noOption} />;
  }

  onSelect(value) {
    const { onSelect, name } = this.props;
    onSelect({ name, value });
  }

  onToggle(isOpen) {
    if (isOpen) {
      this.setState({ isVisible: isOpen });
    } else {
      const { options } = this.props;
      this.setState({ isVisible: isOpen, dropdownOptions: options });
    }
  }

  render() {
    const {
      label = null,
      placeholder = "",
      classes = "",
      id = `select-dropdown-${Date.now()}`,
      value: selectedValue = "",
      error = false,
      text = "",
      disabled = false,
      dropup = false,
    } = this.props;

    const dropdownClassNames = `dropdown ${error ? "form-input-error" : "countryDD w-100"}`;
    const dropdownToggleClassNames = `dropdown-value ${
      selectedValue ? "" : "dropdown-placeholder-text"
    }`;

    return (
      <>
        {label && (
          <label htmlFor={label.for} className={label.classes}>
            {label.content}
          </label>
        )}
        <div className={`${classes}`}>
          <Dropdown
            id={id}
            className={dropdownClassNames}
            onSelect={this.onSelect}
            onToggle={this.onToggle}
            disabled={disabled}
            dropup={dropup}
          >
            <Dropdown.Toggle>
              <>
                <div className={dropdownToggleClassNames}>{selectedValue ? text : placeholder}</div>
                <i className="icon-chevron-down select-arrow t-cl-1" />
              </>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {this.renderSearchFilter()}
              {this.renderOptions()}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    );
  }
}

export default SelectDropdown;
